<template>
  <div class="input-group">
    <v-select
      :disabled="isProcessing"
      style="width: 100%;"
      :options="offices"
      label="display_name"
      :reduce="office => office.id"
      v-model="internalValue"
      @change="onChange">
    </v-select>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  modelValue: {
    type: [String, Number, null],
    default: null
  },
  allowClear: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const store = useStore()
const offices = ref([])
const isProcessing = ref(false)

const internalValue = computed({
  get: () => props.modelValue !== null ? Number(props.modelValue) : null,
  set: (value) => {
    if (value === null && !props.allowClear && props.modelValue !== null) {
      return
    }
    const id = value !== null ? Number(value) : null
    emit('update:modelValue', id)
  }
})

// Methods
const load = async () => {
  try {
    isProcessing.value = true
    const officeList = await store.dispatch('office/getOffices')
    offices.value = officeList

    if (props.modelValue) {
      emit('change', props.modelValue)
    } else if (offices.value.length === 1) {
      internalValue.value = offices.value[0].id
      onChange(offices.value[0].id)
    }
  } catch (error) {
    console.error('Error loading offices:', error)
  } finally {
    isProcessing.value = false
  }
}

const onChange = (value) => {
  const id = value !== null ? Number(value) : null
  emit('change', id)
}

// Lifecycle hooks
onMounted(() => {
  load()
})
</script>

<style scoped>

</style>
